import React, { useEffect, useState, useRef } from "react";
import "../../../styles/Home.scss";
import { VscTriangleLeft, VscTriangleRight } from "react-icons/vsc";
import { FaInstagram, FaFacebookF, FaYoutube, FaTiktok } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";

type VlogItem = {
  id: string;
  type: string;
  url: string;
  social: string;
  social_link: string;
  from: string;
};

const VlogSection: React.FC = () => {
  const [videos, setVideos] = useState<VlogItem[]>([]);
  const [activeIndex, setActiveIndex] = useState<number | null>(null);
  const cardVideoRefs = useRef<(HTMLVideoElement | null)[]>([]);
  const modalVideoRef = useRef<HTMLVideoElement | null>(null);

  useEffect(() => {
    fetch("/assets/vlog.json")
      .then((res) => res.json())
      .then((data) => setVideos(data))
      .catch((err) => console.error("Error loading vlog.json", err));
  }, []);

  useEffect(() => {
    if (activeIndex !== null) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [activeIndex]);

  const openModal = (index: number) => {
    setActiveIndex(index);
    setTimeout(() => {
      if (modalVideoRef.current) {
        modalVideoRef.current.muted = false;
        modalVideoRef.current.currentTime = 0;
        modalVideoRef.current.play();
      }
    }, 50);
  };

  const closeModal = () => {
    if (modalVideoRef.current) {
      modalVideoRef.current.pause();
      modalVideoRef.current.currentTime = 0;
    }
    setActiveIndex(null);
  };

  const nextVideo = () => {
    if (activeIndex === null) return;
    const next = (activeIndex + 1) % videos.length;
    setActiveIndex(next);
  };

  const prevVideo = () => {
    if (activeIndex === null) return;
    const prev = activeIndex === 0 ? videos.length - 1 : activeIndex - 1;
    setActiveIndex(prev);
  };

   const getSocialIcon = (social: string) => {
    switch (social.toLowerCase()) {
      case "instagram":
        return <FaInstagram />;
      case "facebook":
        return <FaFacebookF />;
      case "youtube":
        return <FaYoutube />;
      case "x":
      case "twitter":
        return <FaXTwitter />;
      case "tiktok":
        return <FaTiktok />;
      default:
        return null;
    }
  };

  return (
    <>
      <div className="vlog-section">
        <h3>Vloggit</h3>

        <div className="vlog-container">
          {videos.map((video, index) => (
            <div key={video.id} className="vlog-card-container">
              <div
                className="vlog-card"
                onClick={() => openModal(index)}
              >
                <video
                  ref={(el) => (cardVideoRefs.current[index] = el)}
                  src={video.url}
                  autoPlay
                  muted
                  loop
                  playsInline
                />
              </div>

              <div className="vlog-credit">
                 
                <a
                  href={video.social_link}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {video.from}
                </a>

               {getSocialIcon(video.social)}{" "}
              </div>
            </div>
          ))}
        </div>
      </div>

      {activeIndex !== null && (
        <div className="vlog-modal-overlay" onClick={closeModal}>
          <div className="vlog-modal" onClick={(e) => e.stopPropagation()}>
            <button className="vlog-close" onClick={closeModal}>
              ✕
            </button>

            <video
              ref={modalVideoRef}
              src={videos[activeIndex].url}
              controls
              autoPlay
              playsInline
              style={{ width: "100%", height: "100%", objectFit: "cover" }}
            />

            <button className="vlog-prev" onClick={prevVideo}>
              <VscTriangleLeft size={30} />
            </button>
            <button className="vlog-next" onClick={nextVideo}>
              <VscTriangleRight size={30} />
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default VlogSection;